// Side-effect import makes this file a module so the block below augments the
// existing @ngx-formly/core types (declaration merging) rather than declaring a
// new ambient module.
import '@ngx-formly/core';
import { IDropdownConditionalActionConfig } from '../models/dropdown-conditional-action.model';

/**
 * Module augmentation: add `mixpanelEventAnalytics` to EVERY field's `props`.
 *
 * This is the single setting a service manager toggles ("Track this lookup").
 * When true, the AnalyticsAwareFieldType base class emits the field's lookup
 * outcome. ngx-formly v6 merges interface declarations into FormlyFieldProps,
 * so `field.props?.mixpanelEventAnalytics` is typed on all components.
 *
 * Exporting this file from public-api.ts ships the ambient declaration with the
 * library's type definitions.
 */
declare module '@ngx-formly/core' {
  interface FormlyFieldProps {
    /** When true, this lookup field's success/failure outcome is tracked. */
    mixpanelEventAnalytics?: boolean;

    /** Optional create-and-refresh action for non-paginated custom dropdowns. */
    conditionalAction?: IDropdownConditionalActionConfig;
  }
}
